// Header Components Data
export let navigation_List: string[] = [
    "HOME",
    "ABOUT",
    "SKILL",
    "PROJECT",
    "RESUME",
  ];